document.addEventListener('DOMContentLoaded', function () {
    // Get all the elements we need
    const accountFormClose = document.getElementById("signin-form-close");
    const accountFormMain = document.getElementById("shopify-section-new-sign-in");
    const accountFormOpen = document.getElementById("open-signin-popup");
    const forgotPasswordBtn = document.querySelector('.new-password-toggle');
    const createAccountBtn = document.querySelector('.create-account-toggle');
    const loginForm = document.querySelector('#login-form');
    const signinForm = document.querySelector('#shopify-section-new-sign-in');
    const createAccountTrigger = document.querySelector('#open-register-popup');
    const resetPasswordForm = document.querySelector('#register-form');
    const cancelBtn = document.querySelector('.account-cancel-toggle');

    // Open signin popup
    if (accountFormOpen) {
        accountFormOpen.addEventListener("click", function(){
            resetPasswordForm.classList.add('hide');
            loginForm.classList.remove('hide');
            accountFormMain.style.display = "flex";
        });
    }
    
    // Close signin popup
    if (accountFormClose) {
        accountFormClose.addEventListener("click", function(){
            accountFormMain.style.display = "none";
        });
    }

    // Forgot password button
    if (forgotPasswordBtn) {
        forgotPasswordBtn.addEventListener('click', (event) => {
            event.preventDefault();
            
            // Hide login form
            loginForm.classList.add('hide');
            
            // Show reset password form with !important to override CSS
            resetPasswordForm.classList.remove('hide');
            resetPasswordForm.setAttribute('aria-hidden', 'false');
            resetPasswordForm.style.setProperty('display', 'block', 'important');
        });
    }

    // Cancel button (back to signin)
    if (cancelBtn) {
        cancelBtn.addEventListener('click', (event) => {
            event.preventDefault();
            
            // Show login form
            loginForm.classList.remove('hide');
            
            // Hide reset password form and reset attributes
            resetPasswordForm.classList.add('hide');
            resetPasswordForm.setAttribute('aria-hidden', 'true');
            resetPasswordForm.style.removeProperty('display');
        });
    }

    // Store animation ID globally so we can stop it from other functions
    let accountSignupAnimationId = null;
    
    // Create account button
    if (createAccountBtn) {
        createAccountBtn.addEventListener('click', (event) => {
            event.preventDefault();
            signinForm.style.display = 'none';
            
            // Directly call the showRegisterPopup functionality instead of clicking the button
            const popup = document.querySelector("#shopify-section-new-account-signup");
            const backgroundSetting = document.querySelector(".account-signup-background-setting");
            
            if (popup) {
                // Function to apply styles
                const applyStyles = () => {
                    popup.style.setProperty('display', 'flex', 'important');
                    popup.style.setProperty('position', 'fixed', 'important');
                    popup.style.setProperty('top', '0px', 'important');
                    popup.style.setProperty('left', '0px', 'important');
                    popup.style.setProperty('width', '100%', 'important');
                    popup.style.setProperty('height', '100%', 'important');
                    popup.style.setProperty('z-index', '99999', 'important');
                    popup.style.setProperty('background', 'rgba(0, 0, 0, 0.5)', 'important');
                    popup.style.setProperty('justify-content', 'center', 'important');
                    popup.style.setProperty('align-items', 'center', 'important');
                };
                
                // Apply styles immediately and continuously
                applyStyles();
                
                // Use requestAnimationFrame for smoother, more frequent updates
                const keepStylesApplied = () => {
                    const currentDisplay = window.getComputedStyle(popup).display;
                    if (currentDisplay === 'none') {
                        applyStyles();
                    }
                    accountSignupAnimationId = requestAnimationFrame(keepStylesApplied);
                };
                
                // Start the animation frame loop
                accountSignupAnimationId = requestAnimationFrame(keepStylesApplied);
                
                // Stop after 2 seconds
                setTimeout(() => {
                    if (accountSignupAnimationId) {
                        cancelAnimationFrame(accountSignupAnimationId);
                        accountSignupAnimationId = null;
                    }
                }, 2000);
            }
            
            if (backgroundSetting) {
                backgroundSetting.classList.add("account-signup-background--active");
            }
        });
    }
    
    // Listen for signin popup toggle to stop our animation loop
    const toggleSigninBtn = document.querySelector('#toggle-sign-in-popup');
    if (toggleSigninBtn) {
        toggleSigninBtn.addEventListener('click', () => {
            if (accountSignupAnimationId) {
                cancelAnimationFrame(accountSignupAnimationId);
                accountSignupAnimationId = null;
            }
        });
    }
});
